define('lib/Podio.Bootstrap',['require','underscore','lib/prototype/String.prototype'],function(require) {

  var _ = require('underscore');
  require('lib/prototype/String.prototype');

  var cache = {};

  return {

    getBootstrapData: function(name, optional) {
      var node = this._getScriptElm(name);

      if(_.isElement(node)) {
        var data = JSON.parse(_.unescape(node.innerHTML));

        if (node.parentNode) {
          node.parentNode.removeChild(node);
        }

        cache[name] = data;

        return data;
      }

      var cachedData = cache[name];
      if(!_.isUndefined(cachedData)) {
        return cachedData;
      } else if(!optional) {
        throw "Missing bootstrap data {0}".format(name);
      }
    },

    hasBootstrapData: function(name) {
      if (name in cache) {
        if(_.isEmpty(cache[name])) {
          return false;
        } else {
          return true;
        }
      }

      var elmScript = this._getScriptElm(name);
      return _.isElement(elmScript);
    },

    isInBootstrapCache: function(name) {
      return (name in cache) && !_.isEmpty(cache[name]);
    },

    _getScriptElm: function(name) {
      return document.getElementById('bootstrap-data-{0}'.format(name));
    }
  };
});

